import { KYMW0300OutputModel } from "src/app/commons/kymw03/kymw0300/vo/kymw0300-output.model";
import { GoodsModel } from "./vo/goods.model";
import { PagenationModel } from "./vo/pagenation.model";
import { SearchParamsModel } from "./vo/search-params.model";

export class KYMW6902Model {
  searchParams = new SearchParamsModel();
  pagenation = new PagenationModel();
  goodsList: GoodsModel[] = [];

  selectedRowIndex = 0;

  setSearchParams(kymw0300Output: KYMW0300OutputModel) {
    this.searchParams = new SearchParamsModel(
      kymw0300Output.pcode,
      kymw0300Output.itemCode,
      kymw0300Output.janCode,
      kymw0300Output.makerName,
      kymw0300Output.tagSearchType,
      kymw0300Output.goodsMarkSearchType,
      kymw0300Output.dataKbnFlg,
      kymw0300Output.goodsDiv,
      kymw0300Output.buyerCode,
      kymw0300Output.admitStatus,
      kymw0300Output.registDateFrom,
      kymw0300Output.registDateTo,
      kymw0300Output.updateDateFrom,
      kymw0300Output.updateDateTo,
      kymw0300Output.classCode,
      kymw0300Output.middleClassCode,
      kymw0300Output.smallClassCode,
      kymw0300Output.ordrClientCode,
      kymw0300Output.ordrClientKanji,
      kymw0300Output.payeeClientCode,
      kymw0300Output.payeeClientKanji,
      kymw0300Output.tagId,
      kymw0300Output.goodsMark,
      kymw0300Output.coopCodeList,
      kymw0300Output.pcodeList,
      kymw0300Output.itemcodeList,
      kymw0300Output.duties,
      kymw0300Output.guideGoodsNameList,
      kymw0300Output.guideStandardNameList,
    );
  }
  resetSelectedRowIndex() {
    this.selectedRowIndex = 0;
  }
}